import { Box, Stack, Typography } from '@mui/material'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { SurahIndexList } from './SurahIndexList'
import { buildSurahIndexPath } from '../lib/seo'
import type { SupportedLang } from '../lib/seo'

/**
 * Home-page surah index. Sibling of PopularSurahsSection / PopularAyahsSection,
 * but unlike those it renders real anchors (see SurahIndexList) — it is what
 * gives every surah page an inbound link one click from the home page.
 *
 * Language comes from i18next here, not from a URL param: the home page is a
 * single canonical URL ("/") whose language follows the visitor's UI setting.
 */
export function SurahIndexSection() {
  const { t, i18n } = useTranslation()
  const lang: SupportedLang = i18n.language.toLowerCase().startsWith('fr') ? 'fr' : 'en'

  return (
    <Box component="section" sx={{ mb: 3.5 }}>
      <Stack spacing={0.35} sx={{ mb: 1.75 }}>
        <Stack
          direction="row"
          spacing={1}
          sx={{ alignItems: 'center', justifyContent: 'space-between' }}
        >
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', minWidth: 0 }}>
            <MenuBookIcon sx={{ color: 'primary.main', fontSize: 22 }} />
            <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: '-0.01em' }}>
              {t('home.allSurahs')}
            </Typography>
          </Stack>
          <Typography
            component={RouterLink}
            to={buildSurahIndexPath(lang)}
            variant="body2"
            sx={{
              color: 'primary.main',
              textDecoration: 'none',
              fontWeight: 600,
              flexShrink: 0,
              whiteSpace: 'nowrap',
            }}
          >
            {t('home.allSurahsBrowse')}
          </Typography>
        </Stack>
        <Typography variant="body2" color="text.secondary" sx={{ pl: { xs: 0, sm: 4 } }}>
          {t('home.allSurahsHint')}
        </Typography>
      </Stack>

      <SurahIndexList lang={lang} />
    </Box>
  )
}
